//messages.js
export default {
    account_id: "Account Id",
    account_code: "Account Code",
    account_name: "Account Name",
    account_type: "Account Type",
    is_active: "Active",
    edit_chart_of_account: "Edit Chart Of Account",
    add_chart_of_account: "Add Chart Of Account",
    delete_chart_of_account: "Delete Chart Of Account",
    chart_of_accounts: "Chart Of Accounts",
};
